import { ChangeDetectorRef, Component, Input, OnChanges, OnInit, QueryList, SimpleChanges, ViewChild, ViewChildren } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, FormGroupDirective } from '@angular/forms';
import { UploadDokumentArt } from '../../../../shared/enum';
import { IAntrag } from '../../../models/antrag';
import { FileUploadComponent } from '../../file-upload/file-upload.component';
import { FertigstellenComponent } from '../fertigstellen.component';

@Component({
  selector: 'app-kfz-fertigstellen',
  templateUrl: './kfz-fertigstellen.component.html',
  styleUrls: ['./kfz-fertigstellen.component.scss']
})
export class KfzFertigstellenComponent implements OnInit, OnChanges {

  @Input()
  parentFormGroupDirective: FormGroupDirective;

  @Input()
  formGroup: UntypedFormGroup;

  @Input()
  showBmNachweis: boolean;

  @Input()
  showKaskobesichtigung: boolean;

  @Input()
  showAufstellungSonderausstattung: boolean;

  dokumentArten = UploadDokumentArt;

  @ViewChild(FertigstellenComponent) fertigstellenComponent: FertigstellenComponent;
  @ViewChildren(FileUploadComponent) fileUploadComponents: QueryList<FileUploadComponent>;

  constructor(private ref: ChangeDetectorRef) {}

  static createFormGroup(fb: UntypedFormBuilder) {
    return fb.group({
      fertigstellen: FertigstellenComponent.createFormGroup(fb),
      anmerkungen: new UntypedFormControl(''),
      kopieAnMich: new UntypedFormControl('')
    });
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.showBmNachweis && changes.showBmNachweis.currentValue !== changes.showBmNachweis.previousValue ||
      changes.showKaskobesichtigung && changes.showKaskobesichtigung.currentValue !== changes.showKaskobesichtigung.previousValue ||
      changes.showAufstellungSonderausstattung && changes.showAufstellungSonderausstattung.currentValue !== changes.showAufstellungSonderausstattung.previousValue) {
      this.ref.detectChanges();
    }
  }

  get fertigstellen() { return this.formGroup.get('fertigstellen'); }
  get anmerkungen() { return this.formGroup.get('anmerkungen'); }
  get kopieAnMich() { return this.formGroup.get('kopieAnMich'); }

  get selectedFiles() {
    return this.fertigstellenComponent ? this.fertigstellenComponent.fileUploadComponents.toArray()
      .concat(this.fileUploadComponents.toArray())
      .flatMap(x => x.selectedFiles) : [];
  }

  setAntrag(antrag: IAntrag) {
    this.anmerkungen.setValue(antrag.AnmerkungenUpload);
  }

  getAntrag(): IAntrag {
    return {
      AnmerkungenUpload: this.anmerkungen.value,
      KopieAnMich: this.kopieAnMich.value ? true : false
    } as IAntrag;
  }
}
